import { useEffect } from 'react';
import gsap from 'gsap';
import { isHeroMobileViewport } from '../utils/heroMobile';

export function useHeroCardParallax(heroRef, reducedMotion) {
  useEffect(() => {
    const hero = heroRef.current;
    if (!hero || reducedMotion || isHeroMobileViewport()) return undefined;

    const layers = hero.querySelectorAll('[data-depth]');
    if (layers.length === 0) return undefined;

    const xTo = Array.from(layers).map((el) =>
      gsap.quickTo(el, 'x', { duration: 0.85, ease: 'power2.out' }),
    );
    const yTo = Array.from(layers).map((el) =>
      gsap.quickTo(el, 'y', { duration: 0.85, ease: 'power2.out' }),
    );

    const onMove = (event) => {
      const rect = hero.getBoundingClientRect();
      const nx = ((event.clientX - rect.left) / rect.width - 0.5) * 2;
      const ny = ((event.clientY - rect.top) / rect.height - 0.5) * 2;

      layers.forEach((el, index) => {
        const depth = parseFloat(el.dataset.depth || '0.25');
        xTo[index](nx * 18 * depth);
        yTo[index](ny * 14 * depth);
      });
    };

    window.addEventListener('mousemove', onMove);
    return () => window.removeEventListener('mousemove', onMove);
  }, [heroRef, reducedMotion]);
}

export default useHeroCardParallax;
